<template>
  <div>
    <div class="">
      <div v-html="htmlData"></div>
      <!-- <div>
        <div class="row border-bottom border-dark mb-4">
          <div class="col-4 align-self-center">
            <img
              src="@/assets/img/logos/logo-white.png"
              height="auto"
              width="100"
              class="img-fluid"
              alt
            />
          </div>
          <div class="col-4">
            <div
              v-if="signage_details && signage_details.signage_name"
              class="sinage-title"
            >{{ signage_details.signage_name }}</div>
          </div>
          <div class="col-4 justify-content-end d-flex align-items-center">
            <h5 class="mb-0">{{currentTime}}</h5>
            <h5 class="mb-0 ml-4">{{currentDate}}</h5>
          </div>
        </div>

        <slick ref="slick1" :options="silderOne">
          <div v-for="(show,showKey) in finalMovies" :key="showKey">
            <div class="single-movie">
              <img
                v-if=" show.md_thumbnail_url && show.md_thumbnail_url.length == 0"
                :src="'/static/placeholder-image.png'"
                class="rounded img-fluid d-block mx-auto"
              />
              <img
                v-else
                :src="_GetImagePath(show.md_thumbnail_url)"
                class="rounded img-fluid d-block mx-auto"
              />
              <h5>{{ show.movie_title }}</h5>

              <ul class="sinage-info">
                <li>
                  <div class="sinage-format">{{show.mf_name}}</div>
                </li>
                <li>
                  <div class="sinage-lang">{{show.lang_name}}</div>
                </li>
                <li>
                  <div>({{show.rating}})</div>
                </li>
              </ul>

              <h6></h6>

              <ul class="sinage-timing-list mb-0">
                <li
                  v-for="(showTime,ShowTimeKey) in show.showTimes"
                  :key="ShowTimeKey"
                >{{ showTime }}</li>
              </ul>
            </div>
          </div>
        </slick>
      </div>-->
    </div>
  </div>
</template>

<script type="text/javascript" src= 
        "https://cdnjs.cloudflare.com/ajax/libs/underscore.js/1.9.1/underscore.js">
</script>

<script>
import signageServices from "@/services/signageService";
import Slick from "vue-slick";
import moment from "moment";

export default {
  components: {
    Slick
  },
  sockets: {
    connect: function() {
      console.log("socket connected");
    },
    resetSliderEvent: function(data) {
      console.log("Reset Slider");
      if (window.location.href == data.url) {
        this.resetSlider();
        this.mainReset = false;
      }
    }
  },
  data() {
    return {
      silderOne: {
        infinite: true,
        dots: false,
        arrows: false,
        autoplay: true,
        pauseOnHover: false,
        autoplaySpeed: 40000,
        slidesToScroll: 1,
        slidesToShow: 4
      },
      finalMovies: [],
      signage_details: {},
      mainReset: false,
      htmlData: null
    };
  },
  beforeMount() {
    this.getMovies(this.$route.params.su_id);
    this.mainReset = true;
    //restartAll
  },
  mounted: function() {
    this.$socket.emit("resetSliderEvent", { url: window.location.href });
  },
  watch: {
    $route(to, from) {
      // react to route changes.
      this.getMovies(to.params.su_id);
    }
  },
  computed: {
    currentTime() {
      return this.$store.getters.CURRENT_TIME;
    },
    currentDate() {
      return this.$store.getters.CURRENT_DATE;
    }
  },
  mounted: function() {},
  methods: {
    resetSlider() {
      //TO DO , reset Slider
    },
    getMovies: function(su_id) {
      this.finalMovies = [];
      this.signage_details = {};
      signageServices
        .getDynamicSignage(su_id)
        .then(response => {
          console.log("response :>> ", response);
          this.htmlData = response.data;
          const { data } = response;
          // if (data.status) {
          // this.signage_details = data.signage_details;
          // let movies = data.Records;
          // movies.map(x => {
          //   x["showTimes"] = [];
          // });
          // data.Records.map(x => {
          //   let dateCheck = moment(
          //     moment(x.ss_start_date).format("YYYY-MM-DD")
          //   ).isSame(moment(moment().format("YYYY-MM-DD")));
          //   movies.map(y => {
          //     if (
          //       x.movie_id == y.movie_id &&
          //       x.movie_details_id == y.movie_details_id &&
          //       dateCheck
          //     ) {
          //       y.showTimes.push(x.ss_start_show_time);
          //     }
          //   });
          // });
          // function removeDuplicates(originalArray, prop) {
          //   var newArray = [];
          //   var lookupObject = {};
          //   for (var i in originalArray) {
          //     lookupObject[originalArray[i][prop]] = originalArray[i];
          //   }
          //   for (i in lookupObject) {
          //     newArray.push(lookupObject[i]);
          //   }
          //   return newArray;
          // }
          // this.finalMovies = removeDuplicates(movies, "movie_details_id");
          // this.$refs.slick1.destroy();
          // this.$nextTick(() => {
          //   this.$refs.slick1.create();
          //   this.$refs.slick1.goTo(0, true);
          // });
          // } else {
          //   this.$toasted.show(data.message);
          // }
        })
        .catch(error => {
          this.$toasted.show(error);
          console.log("error :", error);
        });
    }
  }
};
</script>

<style>
.sinage-wrapper {
  width: 100%;
  padding: 20px;
  color: #fff;
  height: 100vh;

  overflow: hidden;
  background: #000000;
  /* fallback for old browsers */
  background: -webkit-linear-gradient(to top, #434343, #000000, #000000);
  /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(to top, #434343, #000000, #000000);
  /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}

.sinage-title {
  height: 65px;
  color: #fff;
  font-size: 40px;
  font-weight: 600;
  text-align: center;
  text-transform: uppercase;
}

.sinage-wrapper .single-movie {
  width: 20%;
  padding: 15px 20px;
  margin: 0 auto;
  text-align: left;
  border-radius: 5px;
  background: #222222;
  /* border: 1px solid grey; */
  margin-top: 10px;
  margin-bottom: 10px;
  box-shadow: 1px 1px 10px 3px #8080807a;
}

.single-movie h5 {
  line-height: 1;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 1px;
  margin-bottom: 20px;
  padding: 18px 0 15px 0;
  text-transform: uppercase;
  border-bottom: 1px solid GREY;
}

.single-movie img {
  width: 100%;
}

.sinage-info,
.sinage-timing-list {
  padding-left: 0;
  list-style: none;
  margin-bottom: 0px;
  display: inline-flex;
  flex-wrap: wrap;
}

.sinage-info li,
.sinage-timing-list li {
  border-radius: 5px;
  flex-wrap: wrap;
  display: flex;
}

.sinage-timing-list li {
  padding: 5px 15px;
  margin-bottom: 10px;
  border: 1px solid grey;
}

.sinage-timing-list li:not(:last-child) {
  margin-right: 10px;
}

.sinage-info li:not(:last-child):after {
  width: 1px;
  content: "";
  height: 20px;
  display: block;
  margin: 0 10px;
  background-color: #d3d3d3;
}

.sinage-format {
  padding: 4px 8px 3px 8px;
  display: table;
  line-height: 1;
  border-radius: 3px;
  border: 1px solid grey;
  background-color: #000000;
}

.single-movie h6 {
  font-size: 16px;
  margin-bottom: 20px;
  letter-spacing: 1px;
  text-transform: uppercase;
}
</style>



// WEBPACK FOOTER //
// src/components/Signage/signageDynamic.vue